import { gql } from '@apollo/client';
import React from 'react';
import { PageFilterAvailabilityFacetFragment } from '../../generated/types/PageFilterAvailabilityFacetFragment';
import { PageFilterPanel } from './PageFilterPanel';
import { PageFilterFacet } from './PageFilterFacet';

import './PageFilterAvailability.scss';

type PageFilterAvailabilityProps = {
  availability: PageFilterAvailabilityFacetFragment | null;
  mobile?: boolean;
  showCounts?: boolean;
  onClose: () => void;
};

type Availabilities = {
  key: 'availableNow' | 'preorder' | 'trunkshow';
  label: string;
  value: string;
}[];

export const PAGE_FILTER_AVAILABILITY_FACET_FRAGMENT = gql`
  fragment PageFilterAvailabilityFacetFragment on AvailabilityFacet {
    availableNow: available_now
    preorder
    trunkshow
  }
`;

export const AVAILABILITIES: Availabilities = [
  { key: 'availableNow', label: 'Available Now', value: 'available_now' },
  { key: 'preorder', label: 'Preorder', value: 'preorder' },
  { key: 'trunkshow', label: 'Trunkshow', value: 'trunkshow' }
];

export const PageFilterAvailability: React.FC<PageFilterAvailabilityProps> = ({
  availability,
  mobile,
  showCounts,
  onClose
}) => {
  if (!availability) return null;

  const availabilities = AVAILABILITIES.map(({ key, label, value }) => {
    if (!availability || !availability[key]) {
      return null;
    }

    return (
      <PageFilterFacet
        facet={{
          filterValue: value,
          name: label,
          slug: '',
          totalItems: availability[key]
        }}
        key={key}
        name="availability"
        showCounts={showCounts}
      />
    );
  });

  if (availabilities.every(availability => availability === null)) return null;

  if (mobile) {
    return (
      <PageFilterPanel onClose={onClose} title="Availability">
        {availabilities}
      </PageFilterPanel>
    );
  }

  return (
    <div className="PageFilterAvailability">
      <h4 className="PageFilterAvailability__title">Availability</h4>
      {availabilities}
    </div>
  );
};
